/**
 * Frappe Backend Konfiguration
 *
 * Die Backend-URL kann auf zwei Arten konfiguriert werden:
 * 1. Environment Variable: VITE_FRAPPE_API_URL (in .env Datei)
 * 2. Runtime über Settings Storage (wird in App gespeichert)
 */

import { settingsStorage } from '../services/storage';

/**
 * Lädt die Frappe Backend URL
 * Priorität: Settings Storage > Environment Variable > Default
 */
export function getFrappeApiUrl(): string {
  // 1. Prüfe Settings Storage (Runtime-Konfiguration)
  const settings = settingsStorage.load();
  if (settings.frappe_url) {
    return settings.frappe_url;
  }

  // 2. Prüfe Environment Variable
  const envUrl = import.meta.env.VITE_FRAPPE_API_URL;
  if (envUrl) {
    return envUrl;
  }

  // 3. Fallback (sollte in Production nicht verwendet werden)
  console.warn('Frappe API URL nicht konfiguriert. Bitte in .env oder Settings setzen.');
  return '';
}

/**
 * Setzt die Frappe Backend URL zur Laufzeit
 */
export function setFrappeApiUrl(url: string): void {
  settingsStorage.update({ frappe_url: url });
}

/**
 * Prüft ob Backend konfiguriert ist
 */
export function isFrappeConfigured(): boolean {
  return getFrappeApiUrl() !== '';
}
